const useChatContext = () => {
    const setChatContext = (context: string) => {
        window.dispatchEvent(new CustomEvent('chat-start-value', { detail: context }));
    };

    return {
        setChatContext
    };
};

export default useChatContext;
